import { environment } from '@/assets/environment';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { IContactsState } from '@/models/store/contacts/contact-state.model';
import { IContact } from '@/models/store/contacts/contact.model';
import { Module } from 'vuex';

const contactsModule: Module<IContactsState, unknown> = {
    state: {
        contacts: [],
    },

    actions: {
        getContacts: async ({ commit }) => {
            const response = await fetch(`${environment.baseUrl}/api/contacts`, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const contacts = (await response.json()).contacts;
            commit('setContacts', contacts);
        },
    },

    mutations: {
        setContacts: (store, payload: IContact[]): void => {
            store.contacts = [...payload];
        },
    },

    getters: {
        getContacts: (store) => store.contacts,
    },
};

export default contactsModule;
